import ServiceImg from "../Assets/Images/ServicesImage.jpg";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ServiceContent = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      offset: 200,
    });
  }, []);
  return (
    <div>
      <div className="max-w-[1140px] mx-auto pt-10 my-28 p-4">
        <div className="grid place-items-center lg:grid-cols-2 gap-10 md:grid-cols-1">
          <div className="p-4">
            <h1
              data-aos="fade-right"
              className="text-2xl sm:text-3xl lg:text-4xl font-bold sm:leading-10 text-white"
            >
              What We <span className="text-gradient">Offer</span>
            </h1>
            <div className="web3-underline w-[70px] mt-3"></div>
            <p className="py-6 text-md text-gray-400">
              We are a software solutions company helping all kinds of enterprises
              implement the latest technologies by using innovative strategies
              to enhance their productivity and accelerate their growth so that
              they can make a name for themselves in the digital landscape. We
              offer a variety of services to cater to your business needs. From
              our software solutions, Artificial Intelligence,
              Software Development, Digital Marketing, to Logistics & Transport
              services, we’ve got you covered. Whether it’s a startup or an
              enterprise, we offer services that fit your company’s needs
            </p>
          </div>
          <div>
            <img src={ServiceImg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceContent;
